import React, { useEffect, useState, useRef } from 'react';
import { Heart, X, Star, MessageCircle, ChevronLeft, Sparkles, Trophy, Gift } from 'lucide-react';
interface Character {
  id: string;
  name: string;
  image: string;
  tags: string[];
  description: string;
  rating: number;
  votes: number;
}
interface HotOrNotSectionProps {
  onBack: () => void;
}
export const HotOrNotSection: React.FC<HotOrNotSectionProps> = ({
  onBack
}) => {
  const [characters, setCharacters] = useState<Character[]>([{
    id: '1',
    name: 'Sophia',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7NtKFxdUp5woHYjkw88Xiz/00_cover_%282%29.jpg',
    tags: ['Playful', 'Innocent', 'Redhead'],
    description: 'Playful redhead who loves adventures and spontaneous fun',
    rating: 4.8,
    votes: 1243
  }, {
    id: '2',
    name: 'Amber',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/o14GLvGiKieL28wgrCuCbN/00_cover_%283%29.jpg',
    tags: ['Blonde', 'Flirty', 'Beach Lover'],
    description: 'Sunny beach girl with a flirty attitude and adventurous spirit',
    rating: 4.7,
    votes: 987
  }, {
    id: '3',
    name: 'Destiny',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hV9Ch4wDNnMZBriUSQWH8D/00_cover.jpg',
    tags: ['Blonde', 'Submissive', 'Kinky'],
    description: 'Sweet on the streets, wild in the sheets',
    rating: 4.9,
    votes: 2156
  }, {
    id: '4',
    name: 'Ruby',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b5oZyVHzjUmuaEsxBqjSTy/00_cover.jpg',
    tags: ['Redhead', 'Dominant', 'Seductive'],
    description: 'Fiery redhead who knows exactly what she wants',
    rating: 4.6,
    votes: 1872
  }, {
    id: '5',
    name: 'Lily',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2ymoVEnFd6ubrrcuvZm6Xc/04_2.jpg',
    tags: ['Brunette', 'Barista', 'Girl Next Door'],
    description: "The cute barista you've been crushing on",
    rating: 4.5,
    votes: 1354
  }, {
    id: '6',
    name: 'Harper',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    tags: ['Icy', 'Mysterious', 'Elite'],
    description: 'Ice blue eyes, fire-hot touch',
    rating: 4.8,
    votes: 1762
  }, {
    id: '7',
    name: 'Bonny Blue',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    tags: ['Dominant', 'Playful', 'Blonde'],
    description: 'Dominant & playful, here to fulfill your desires',
    rating: 4.7,
    votes: 1589
  }, {
    id: '8',
    name: 'Lana',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    tags: ['Blonde', 'Fantasy', 'Luxury'],
    description: 'Your blonde fantasy come true',
    rating: 4.9,
    votes: 2345
  }]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState<'left' | 'right' | null>(null);
  const [votes, setVotes] = useState(0);
  const [votingStreak, setVotingStreak] = useState(0);
  const [showUpsell, setShowUpsell] = useState<'hot' | 'not' | 'streak' | null>(null);
  const [xpEarned, setXpEarned] = useState(0);
  const [tokensEarned, setTokensEarned] = useState(0);
  const [showReward, setShowReward] = useState(false);
  const [favorites, setFavorites] = useState<string[]>([]);
  const cardRef = useRef<HTMLDivElement>(null);
  const maxVotes = 20; // Maximum daily votes
  useEffect(() => {
    // Shuffle the characters array on component mount
    const shuffled = [...characters].sort(() => Math.random() - 0.5);
    setCharacters(shuffled);
  }, []);
  const handleVote = (isHot: boolean) => {
    if (currentIndex >= characters.length) return;
    // Track vote direction for animation
    setDirection(isHot ? 'right' : 'left');
    // Update character rating
    const updatedCharacters = [...characters];
    const character = updatedCharacters[currentIndex];
    // Update ratings based on vote
    if (isHot) {
      character.rating = (character.rating * character.votes + 5) / (character.votes + 1);
    } else {
      character.rating = (character.rating * character.votes + 2) / (character.votes + 1);
    }
    character.votes += 1;
    setCharacters(updatedCharacters);
    // Increment votes and check for rewards
    const newVotes = votes + 1;
    const newStreak = votingStreak + 1;
    setVotes(newVotes);
    setVotingStreak(newStreak);
    // Show upsell based on vote and random chance
    if (isHot && Math.random() > 0.7) {
      setShowUpsell('hot');
    } else if (!isHot && Math.random() > 0.8) {
      setShowUpsell('not');
    } else if (newStreak === 10) {
      setShowUpsell('streak');
    } else {
      setShowUpsell(null);
    }
    // Check for rewards (every 3 votes)
    if (newVotes % 3 === 0) {
      setXpEarned(10);
      setTokensEarned(5);
      setShowReward(true);
      setTimeout(() => setShowReward(false), 3000);
    }
    // Bonus for 10-vote streak
    if (newStreak === 10) {
      setXpEarned(50);
      setTokensEarned(50);
      setShowReward(true);
      setTimeout(() => setShowReward(false), 3000);
      setVotingStreak(0); // Reset streak after bonus
    }
    // Animate card away
    if (cardRef.current) {
      const card = cardRef.current;
      card.style.transition = 'transform 0.5s ease';
      card.style.transform = isHot ? 'translateX(150%) rotate(30deg)' : 'translateX(-150%) rotate(-30deg)';
      // Move to next card after animation
      setTimeout(() => {
        setCurrentIndex(currentIndex + 1);
        setDirection(null);
        if (card) {
          card.style.transition = 'none';
          card.style.transform = 'translateX(0) rotate(0)';
        }
      }, 500);
    }
  };
  const toggleFavorite = (e: React.MouseEvent, id: string) => {
    e.stopPropagation();
    setFavorites(prev => prev.includes(id) ? prev.filter(fav => fav !== id) : [...prev, id]);
  };
  const resetCards = () => {
    // Shuffle the characters array and reset index
    const shuffled = [...characters].sort(() => Math.random() - 0.5);
    setCharacters(shuffled);
    setCurrentIndex(0);
  };
  const renderUpsell = () => {
    if (!showUpsell) return null;
    switch (showUpsell) {
      case 'hot':
        return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/30 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-8549">
            <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl border border-pink-200 dark:border-pink-700 overflow-hidden animate-in zoom-in-90 duration-300 shadow-lg" data-id="element-8550">
              <div className="p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-8551">
                <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100" data-id="element-8552">
                  🔥 She's Trending!
                </h3>
              </div>
              <div className="p-4" data-id="element-8553">
                <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-8554">
                  {characters[currentIndex - 1]?.name} is one of our hottest
                  Angels right now! Want to see her exclusive VR scene?
                </p>
                <div className="flex gap-3 mt-6" data-id="element-8555">
                  <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700" onClick={() => setShowUpsell(null)} data-id="element-8556">
                    Not Now
                  </button>
                  <button className="flex-1 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-white text-sm font-medium hover:shadow-md hover:shadow-pink-500/20" onClick={() => {
                  // Handle unlock scene
                  setShowUpsell(null);
                }} data-id="element-8557">
                    Unlock Scene (25 💎)
                  </button>
                </div>
              </div>
            </div>
          </div>;
      case 'not':
        return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/30 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-8558">
            <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden animate-in zoom-in-90 duration-300 shadow-lg" data-id="element-8559">
              <div className="p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-8560">
                <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100" data-id="element-8561">
                  Not Your Type?
                </h3>
              </div>
              <div className="p-4" data-id="element-8562">
                <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-8563">
                  Try our Naughty Nerds bundle – 3 Angels made just for you
                  based on your preferences.
                </p>
                <div className="flex gap-3 mt-6" data-id="element-8564">
                  <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700" onClick={() => setShowUpsell(null)} data-id="element-8565">
                    Skip
                  </button>
                  <button className="flex-1 py-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg text-white text-sm font-medium hover:shadow-md hover:shadow-blue-500/20" onClick={() => {
                  // Handle explore bundle
                  setShowUpsell(null);
                }} data-id="element-8566">
                    Explore Bundle
                  </button>
                </div>
              </div>
            </div>
          </div>;
      case 'streak':
        return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/30 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-8567">
            <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl border border-pink-200 dark:border-pink-700 overflow-hidden animate-in zoom-in-90 duration-300 shadow-lg" data-id="element-8568">
              <div className="p-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-pink-500/10 to-purple-500/10 dark:from-pink-500/20 dark:to-purple-500/20" data-id="element-8569">
                <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100 flex items-center" data-id="element-8570">
                  <Sparkles size={20} className="text-yellow-500 mr-2" data-id="element-8571" />
                  Elite 10 Pack Unlocked!
                </h3>
              </div>
              <div className="p-4" data-id="element-8572">
                <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-8573">
                  You've liked 10 of our hottest girls! Want access to the
                  "Elite 10" pack with exclusive content?
                </p>
                <div className="flex gap-3 mt-6" data-id="element-8574">
                  <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700" onClick={() => setShowUpsell(null)} data-id="element-8575">
                    Maybe Later
                  </button>
                  <button className="flex-1 py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg text-white text-sm font-medium hover:shadow-md hover:shadow-pink-500/20" onClick={() => {
                  // Handle elite pack access
                  setShowUpsell(null);
                }} data-id="element-8576">
                    Get Elite Access
                  </button>
                </div>
              </div>
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <div className="w-full min-h-screen bg-white dark:bg-black text-gray-800 dark:text-gray-100 relative" data-id="element-8577">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white dark:bg-black shadow-sm border-b border-gray-200 dark:border-gray-800 px-4 py-3 flex items-center" data-id="element-8578">
        <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-900 rounded-full" onClick={onBack} data-id="element-8579">
          <ChevronLeft size={18} className="text-gray-600 dark:text-gray-400" data-id="element-8580" />
        </button>
        <div className="ml-2" data-id="element-8581">
          <h1 className="font-bold text-lg" data-id="element-8582">Character Hot or Not</h1>
          <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8583">
            Rate our AI characters and help them become more popular
          </p>
        </div>
      </div>
      {/* Main Content */}
      <div className="px-4 py-6 flex flex-col items-center justify-center min-h-[calc(100vh-70px)]" data-id="element-8584">
        {/* Progress bar */}
        <div className="w-full max-w-md mb-6" data-id="element-8585">
          <div className="flex items-center justify-between mb-2" data-id="element-8586">
            <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-8587">
              Votes Today: {votes} / {maxVotes}
            </span>
            <span className="text-sm text-pink-500" data-id="element-8588">
              {votingStreak > 0 && <span className="flex items-center" data-id="element-8589">
                  <Sparkles size={14} className="mr-1" data-id="element-8590" />
                  Streak: {votingStreak}
                </span>}
            </span>
          </div>
          <div className="h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-8591">
            <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-300" style={{
            width: `${votes / maxVotes * 100}%`
          }} data-id="element-8592"></div>
          </div>
          {votes >= maxVotes && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-8593">
              You've reached your daily limit! Come back tomorrow for more.
            </p>}
        </div>
        {/* Card Stack */}
        <div className="relative w-full max-w-md aspect-[3/4] mb-8" data-id="element-8594">
          {currentIndex < characters.length ? <div ref={cardRef} className="absolute inset-0 bg-white dark:bg-black rounded-2xl overflow-hidden border border-gray-200 dark:border-gray-700 shadow-lg" data-id="element-8595">
              <div className="relative h-full" data-id="element-8596">
                <img src={characters[currentIndex].image} alt={characters[currentIndex].name} className="w-full h-full object-cover" data-id="element-8597" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-4" data-id="element-8598">
                  <div className="flex items-center justify-between mb-2" data-id="element-8599">
                    <h3 className="text-xl font-bold text-white" data-id="element-8600">
                      {characters[currentIndex].name}
                    </h3>
                    <button className={`p-2 rounded-full ${favorites.includes(characters[currentIndex].id) ? 'bg-pink-500/30 text-pink-400' : 'bg-gray-200/60 dark:bg-gray-800/60 text-gray-600 dark:text-gray-400'}`} onClick={e => toggleFavorite(e, characters[currentIndex].id)} data-id="element-8601">
                      <Star size={18} fill={favorites.includes(characters[currentIndex].id) ? 'currentColor' : 'none'} data-id="element-8602" />
                    </button>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-3" data-id="element-8603">
                    {characters[currentIndex].tags.map((tag, index) => <span key={index} className="px-2 py-1 bg-gray-200/60 dark:bg-gray-800/60 rounded-full text-xs text-white" data-id="element-8604">
                        {tag}
                      </span>)}
                  </div>
                  <p className="text-sm text-white" data-id="element-8605">
                    {characters[currentIndex].description}
                  </p>
                  <div className="mt-4 flex justify-center gap-4" data-id="element-8606">
                    <button className="px-4 py-2 bg-white/80 dark:bg-gray-800/80 hover:bg-white dark:hover:bg-gray-700 rounded-full text-gray-800 dark:text-gray-200 flex items-center gap-2 transition-colors" onClick={() => {
                  // Navigate to chat
                  const navigateEvent = new CustomEvent('navigate', {
                    detail: {
                      section: 'chat'
                    }
                  });
                  document.dispatchEvent(navigateEvent);
                }} data-id="element-8607">
                      <MessageCircle size={18} data-id="element-8608" />
                      <span data-id="element-8609">Chat Now</span>
                    </button>
                  </div>
                </div>
              </div>
            </div> : <div className="absolute inset-0 bg-white dark:bg-black rounded-2xl overflow-hidden border border-gray-200 shadow-lg flex flex-col items-center justify-center p-6 text-center" data-id="element-8610">
              <div className="w-16 h-16 bg-gray-100 dark:bg-gray-900 rounded-full flex items-center justify-center mb-4" data-id="element-8611">
                <Trophy size={24} className="text-pink-500" data-id="element-8612" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-8613">
                You've rated all characters!
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-8614">
                Come back later for new Angels or reset to start over.
              </p>
              <button className="px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full text-white font-medium hover:shadow-md hover:shadow-pink-500/20" onClick={resetCards} data-id="element-8615">
                Start Over
              </button>
            </div>}
        </div>
        {/* Vote Buttons */}
        {currentIndex < characters.length && <div className="flex items-center justify-center gap-8" data-id="element-8616">
            <button className="w-16 h-16 flex items-center justify-center bg-gray-100 dark:bg-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-full text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-all transform hover:scale-110" onClick={() => handleVote(false)} disabled={votes >= maxVotes} data-id="element-8617">
              <X size={32} data-id="element-8618" />
            </button>
            <button className="w-16 h-16 flex items-center justify-center bg-gradient-to-r from-pink-500 to-purple-500 rounded-full text-white shadow-lg shadow-pink-500/20 transition-all transform hover:scale-110" onClick={() => handleVote(true)} disabled={votes >= maxVotes} data-id="element-8619">
              <Heart size={32} fill="currentColor" data-id="element-8620" />
            </button>
          </div>}
      </div>
      {/* Reward Animation */}
      {showReward && <div className="fixed inset-0 z-40 flex items-center justify-center pointer-events-none" data-id="element-8621">
          <div className="bg-white dark:bg-black shadow-lg rounded-xl p-6 animate-bounce-in" data-id="element-8622">
            <div className="text-center" data-id="element-8623">
              <div className="flex items-center justify-center gap-4 mb-3" data-id="element-8624">
                <div className="flex items-center" data-id="element-8625">
                  <Trophy size={20} className="text-yellow-500 mr-1" data-id="element-8626" />
                  <span className="text-yellow-600 dark:text-yellow-400 font-bold" data-id="element-8627">
                    +{xpEarned} XP
                  </span>
                </div>
                <div className="flex items-center" data-id="element-8628">
                  <Gift size={20} className="text-pink-500 mr-1" data-id="element-8629" />
                  <span className="text-pink-600 dark:text-pink-400 font-bold" data-id="element-8630">
                    +{tokensEarned} 💎
                  </span>
                </div>
              </div>
              <p className="text-gray-800 dark:text-gray-200 text-sm" data-id="element-8631">
                Keep rating for more rewards!
              </p>
            </div>
          </div>
        </div>}
      {/* Upsell Modal */}
      {renderUpsell()}
      {/* Custom Animation Styles */}
      <style jsx data-id="element-8632">{`
        @keyframes bounce-in {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          50% {
            opacity: 1;
            transform: scale(1.1);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-bounce-in {
          animation: bounce-in 0.5s ease-out forwards;
        }
      `}</style>
    </div>;
};